import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00b29151"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-tela-conteudo" }
const _hoisted_5 = {
  class: "ant-row",
  style: {"height":"100%"}
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"ant-col ant-col-xs-0 ant-col-xl-7\" data-v-00b29151><div class=\"ss-card ss-card-space ss-tela-altura-completa\" data-v-00b29151><div class=\"ant-row\" data-v-00b29151><div class=\"ant-col ant-col-xs-24 ant-col-xl-24\" data-v-00b29151><div class=\"ss-tela-informacoes\" data-v-00b29151><img src=\"/static/img/ilustracoes/notificacoes.png\" alt=\"Gerencie e organize!\" data-v-00b29151><div class=\"ss-tela-informacoes-introducao\" data-v-00b29151><h2 data-v-00b29151>Interatividade é tudo!</h2><span data-v-00b29151>Aproveite as notificações para se manter</span><br data-v-00b29151><span data-v-00b29151>atualizado de tudo que ocorre no sistema, seja:</span><br data-v-00b29151><span data-v-00b29151>Processos, tarefas e atividades relacionadas a você.</span></div></div></div></div></div></div>", 1)
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-17" }
const _hoisted_8 = { class: "ss-card ss-card-space ss-tela-altura-completa" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tipo:")
], -1))
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-alinhar-centro" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, null, -1))
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "ss-linha-separacao" }, null, -1))
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = { class: "atbd-top-dropdwon" }
const _hoisted_19 = {
  key: 0,
  class: "ss-alinhar-centro"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "atbd-top-dropdwon-nav notificacao-bs-list"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "atbd-top-dropdwon-content notificacoes" }
const _hoisted_25 = {
  key: 0,
  class: "notificacao-bs-icon bg-primary"
}
const _hoisted_26 = {
  key: 1,
  class: "notificacao-bs-icon bg-primary"
}
const _hoisted_27 = { class: "ss-abreviacao-recurso" }
const _hoisted_28 = { class: "notificacao-bs-content d-flex" }
const _hoisted_29 = { class: "notificacao-bs-texto" }
const _hoisted_30 = { class: "notificacao-bs-status" }
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Carregar mais", -1))
const _hoisted_34 = [
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_badge = _resolveComponent("a-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: '',
          tituloRecurso: 'Notificações',
          exibirAtalhosTela: false,
          exibirHistoricoTela: false,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas
        }, null, 8, ["empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_select, {
                      onChange: _ctx.filtrarNotificacoes,
                      value: _ctx.state.tipo,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tipo) = $event)),
                      class: "ss-tamanho-completo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Todos")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Normal")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Importante")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 3 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Urgente")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onChange", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_a_checkbox, {
                      onChange: _ctx.filtrarNotificacoes,
                      checked: _ctx.state.lidas,
                      "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.lidas) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Lidas")
                      ]),
                      _: 1
                    }, 8, ["onChange", "checked"]),
                    _createVNode(_component_a_checkbox, {
                      onChange: _ctx.filtrarNotificacoes,
                      checked: _ctx.state.pendentes,
                      "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.pendentes) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Pendentes")
                      ]),
                      _: 1
                    }, 8, ["onChange", "checked"])
                  ]),
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.excluirTodasNotificacoes && _ctx.excluirTodasNotificacoes(...args))),
                      type: "button",
                      class: "ant-btn ant-btn-block ant-btn-secondary"
                    }, " Remover todas ", 512), [
                      [_vShow, _ctx.state.notificacoes.length > 0]
                    ])
                  ])
                ]),
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      (_ctx.state.buscandoNotificacoes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_a_spin, { size: "large" })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (_ctx.state.notificacoes.length == 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createVNode(_component_a_empty, { description: 'Você não possui nenhuma notificação.' }, null, 8, ["description"])
                                ]))
                              : (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.notificacoes, (notificacao) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: notificacao.codigo
                                    }, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.acessarLinkNotificacao(notificacao))
                                      }, [
                                        _createElementVNode("div", _hoisted_24, [
                                          (notificacao.icone)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                _createVNode(_component_icone, {
                                                  nome: notificacao.icone
                                                }, null, 8, ["nome"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.obterAbreviacaoRecurso(notificacao.recurso)), 1)
                                              ])),
                                          _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, [
                                              _createElementVNode("h1", null, _toDisplayString(notificacao.titulo), 1),
                                              _createElementVNode("p", null, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(notificacao.dataCriacao)), 1),
                                              _createElementVNode("h2", null, _toDisplayString(notificacao.mensagem), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_30, [
                                              _createVNode(_component_a_badge, {
                                                color: _ctx.obterCorNotificacao(notificacao.tipo),
                                                dot: ""
                                              }, null, 8, ["color"])
                                            ])
                                          ])
                                        ])
                                      ], 8, _hoisted_23)
                                    ]))
                                  }), 128))
                                ]))
                          ]))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.obterNotificacoes && _ctx.obterNotificacoes(...args))),
                      type: "button",
                      class: "ant-btn ant-btn-block ant-btn-secondary"
                    }, _hoisted_34, 512), [
                      [_vShow, _ctx.state.notificacoes.length > 0]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}